import request from '~services/request';
export const ConfigService = {
    getOne: () => request.get(`/config/show`).then(response => response.data),
    update: (data) => request.post('/config/set_config', data).then(response => response.data)
};
